import type { RouteObject } from "react-router";

import { ErrorPage } from "@/components/Error/ErrorPage";
import { canAccessBuildings } from "@/components/ProjectSidebar/permissions";
import { RequireAuth } from "@/components/Routing/RequireAuth";
import { canManageBuildings } from "@/helpers/permissions";

import { buildingRoutes } from "./routes";

export const buildingsRoute = [
  {
    path: buildingRoutes.list,
    lazy: async () => {
      const { BuildingListPage } = await import("./pages/BuildingListPage");

      return {
        element: (
          <RequireAuth permission={canAccessBuildings}>
            <BuildingListPage />
          </RequireAuth>
        ),
      };
    },
  },
  {
    path: buildingRoutes.new,
    lazy: async () => {
      const { CreateBuildingPage } = await import("./pages/CreateBuildingPage");

      return {
        element: (
          <RequireAuth permission={canManageBuildings}>
            <CreateBuildingPage />
          </RequireAuth>
        ),
      };
    },
  },
  {
    path: buildingRoutes.edit,
    lazy: async () => {
      const { EditBuildingPage } = await import("./pages/EditBuildingPage");

      return {
        element: (
          <RequireAuth permission={canManageBuildings}>
            <EditBuildingPage />
          </RequireAuth>
        ),
      };
    },
  },
  {
    path: "*",
    element: <ErrorPage status={404} />,
  },
] satisfies RouteObject[];
